const selectorFactory = (createOrdersInAccountSelector, activeWalletAccountSelector) => (state) =>
  createOrdersInAccountSelector(activeWalletAccountSelector(state))(state)

const ordersInActiveAccountSelectorDefinition = {
  id: 'ordersInActiveAccount',
  selectorFactory,
  dependencies: [
    { selector: 'createOrdersInAccount' },
    { module: 'walletAccounts', selector: 'active' },
  ],
}

export default ordersInActiveAccountSelectorDefinition
